import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Utils
import { translation } from '../../../../utils/helpers'

// Elements
import DropDown from '../../../elements/dropDown'

class Customer extends Component {
  renderOptions () {
    return this.props.customers
      .filter(c => c.Active && c.RelationType !== 1)
      .map((c, i) => {
        if (c.IsApromasWorkshop) {
          return <option value={c.CustomerId} style={{color: 'grey'}} key={i}>{c.Name}</option>
        } else {
          return <option value={c.CustomerId} key={i}>{c.Name}</option>
        }
      })
  }

  render () {
    const { allowNoCustomer, bodyShop, onInputChange, selected } = this.props
    const label = bodyShop ? '14780' : '35'
    let customerNotSelected = null
    if (allowNoCustomer) {
      customerNotSelected = <option value='-1'>{translation('15330')}</option>
    }
    return (
      <DropDown labelText={translation(label)} name='CustomerId' value={selected} onChange={onInputChange}>
        <option value='0'>{translation('2259')}</option>
        {customerNotSelected}
        {this.renderOptions()}
      </DropDown>
    )
  }
}

Customer.propTypes = {
  selected: PropTypes.number.isRequired,
  onInputChange: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    allowNoCustomer: state.auth.allowNoCustomer,
    customers: state.common.customers
  }
}

export default connect(mapStateToProps)(Customer)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/Customer/index.js